// extracted by mini-css-extract-plugin
export default {"tooltip":"Usc0r_","visible":"zqU_6o"};